import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "filter-sort-drawer__sort-wrapper" }
const _hoisted_2 = { class: "filter-sort-drawer__dropdown-wrapper" }
const _hoisted_3 = { class: "filter-sort-drawer__header-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    class: "filter-sort-drawer",
    width: 300,
    modelValue: _ctx.isOpen,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isOpen) = $event)),
    scrim: true,
    temporary: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[5] || (_cache[5] = _createElementVNode("h2", null, "Filter & Sort", -1)),
            _createVNode(_component_v_icon, {
              class: "filter-sort-drawer__close-icon",
              icon: "$close",
              size: "24",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.isOpen = false), ["stop"]))
            })
          ]),
          _createVNode(_component_v_select, {
            class: "filter-sort-drawer__sort-dropdown",
            label: "Sort",
            variant: "underlined",
            items: _ctx.sortOptions,
            modelValue: _ctx.selectedSort,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedSort) = $event)),
              _ctx.applySelectedSort
            ],
            "item-text": "title",
            "item-value": "value"
          }, null, 8, ["items", "modelValue", "onUpdate:modelValue"]),
          _createVNode(_component_v_select, {
            class: "filter-sort-drawer__sort-dropdown",
            modelValue: _ctx.selectedMeditationTypes,
            "onUpdate:modelValue": [
              _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedMeditationTypes) = $event)),
              _ctx.onMeditationTypeChange
            ],
            items: _ctx.meditationOptions,
            label: "Meditation Type",
            multiple: "",
            chips: "",
            clearable: "",
            variant: "underlined"
          }, null, 8, ["modelValue", "items", "onUpdate:modelValue"]),
          _createVNode(_component_v_select, {
            class: "filter-sort-drawer__sort-dropdown",
            modelValue: _ctx.selectedLengths,
            "onUpdate:modelValue": [
              _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedLengths) = $event)),
              _ctx.onLengthChange
            ],
            items: _ctx.lengthOptions,
            label: "Duration (max minutes)",
            multiple: "",
            chips: "",
            clearable: "",
            variant: "underlined"
          }, null, 8, ["modelValue", "items", "onUpdate:modelValue"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}